import { EMPTY_LIST } from '../../../constants/common'
import { NotificationInline } from '../../Notification'

import * as styles from './ConfirmationModalNotifications.module.css'

function ConfirmationModalNotifications({
  Element = 'div',
  className = styles.ConfirmationModalNotifications,
  notifications = EMPTY_LIST,
  ...elementProps
}) {
  return notifications.length > 0 ? (
    <Element {...elementProps} className={className}>
      {notifications.map(notification => (
        <NotificationInline {...notification} key={notification.text} />
      ))}
    </Element>
  ) : null
}

export default ConfirmationModalNotifications
